import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { UserAuthGuard } from './_routeguards/user.authguard';




export const routes: Routes = [

  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },

  {
    path: 'notFound',
    loadChildren: () => import('./views/notFound/notFound.module').then(m => m.NotFoundModule)
  },

  {
    path: 'login',
    loadChildren: () => import('./views/login/login.module').then(m => m.LoginModule)
  },

  {
    path: 'forgot',
    loadChildren: () => import('./views/forgot/forgot.module').then(m => m.ForgotModule)
  },

  {
    path: 'resetpassword',
    loadChildren: () => import('./views/reset/reset.module').then(m => m.ResetModule)
  },

  {
    path: '',
    component: DefaultLayoutComponent, canActivate: [UserAuthGuard],
    children: [
      { path: 'dashboard', loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'event', loadChildren: () => import('./views/event/event.module').then(m => m.EventModule) },
      { path: 'subscriber', loadChildren: () => import('./views/subscribe/subscriber.module').then(m => m.SubscriberModule) },
      { path: 'manifestation', loadChildren: () => import('./views/manifestation/manifestation.module').then(m => m.ManifestationModule) },
    ]
  },

  {
    path: '**',
    redirectTo: '/notFound'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
